export function Toggle({ value, onChange, testID }) {
  return (
    <button
      type="button"
      data-testid={testID}
      data-on={value ? "true" : "false"}
      className="ember-switch"
      aria-pressed={value}
      onClick={() => onChange(!value)}
    >
      <span className="ember-knob" />
    </button>
  );
}

export function Spinner({ size = 28, color = "#1F6E7E" }) {
  return (
    <span
      className="ember-spin"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        border: `${Math.max(2, size / 10)}px solid ${color}33`,
        borderTopColor: color,
      }}
    />
  );
}
